import mitt from "mitt";
import Util from "@/helper/Utility.js";
/**
 * setting
 * @method clearModal
 * @method setTel
 * @method setRefcode
 * @method setEnableRequestOtp
 * @method setDisableRequestOtp
 * action
 * @method show
 * @method hide
 * @method startOtp
 * @method setErrorMsg
 * set event callback
 * @method onClickResendOtp
 * @method onErrorApi
 * @method onSubmitOtp
 * event
 * @event sendCallbackResendOtp
 * @event sendCallbackErrorApi
 * @event sendCallbackSubmitOtp
 */
export function OtpModalController () {
    this.busModal = mitt();

    this.tel = null;
    this.refcode = null;
    this.enableRequest = null;

    this.callbackResendOtp = null;
    this.callbackErrorApi = null;
    this.callbackSubmitOtp = null;

    //#region setter
    this.clearModal = function() {
        this.tel = null;
        this.refcode = null;
        this.enableRequest = null;

        this.callbackResendOtp = null;
        this.callbackErrorApi = null;
        this.callbackSubmitOtp = null;
        return this;
    };
    this.setTel = function (tel) {
        this.tel = tel;
        return this;
    };
    this.setRefcode = function (refcode) {
        this.refcode = refcode;
        return this;
    };
    this.setEnableRequestOtp = function () {
        this.enableRequest = true;
        return this;
    };
    this.setDisableRequestOtp = function () {
        this.enableRequest = false;
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        this.busModal.emit('show');
    };
    this.hide = function() {
        this.busModal.emit('hide');
    };
    this.startOtp = function () {
        var config = {
            tel: this.tel,
            refcode: this.refcode,
            enableRequest :this.enableRequest,
        };
        this.busModal.emit('startOtp', config);
    };
    this.setErrorMsg = function (text) {
        this.busModal.emit('setErrorMsg', text);
    };
    this.clearInputOtp = function () {
        this.busModal.emit('clearInputOtp');
    };
    this.closeOtp = function() {
        this.busModal.emit('closeOtp');
    },
    //#endregion method

    //#region event
    this.onClickResendOtp = function (callback) {
        if (Util.isFunction(callback)) {
            this.callbackResendOtp = callback;
        }
    };
    this.sendCallbackResendOtp = function (data) {
        if (Util.isFunction(this.callbackResendOtp)) {
            this.callbackResendOtp(data);
        }
    };

    this.onErrorApi = function (callback) {
        if (Util.isFunction(callback)) {
            this.callbackErrorApi = callback;
        }
    };
    this.sendCallbackErrorApi = function (data) {
        if (Util.isFunction(this.callbackErrorApi)) {
            this.callbackErrorApi(data);
        }
    };

    this.onSubmitOtp = function (callback) {
        if (Util.isFunction(callback)) {
            this.callbackSubmitOtp = callback;
        }
    };
    this.sendCallbackSubmitOtp = function (data) {
        if (Util.isFunction(this.callbackSubmitOtp)) {
            this.callbackSubmitOtp(data);
        }
    };
    //#endregion event
}
